import { PAYLATER_TYPES } from "@swiggy-private/payment-types";

export interface PayLaterTestIds {
    CONTAINER: string;
    ICON: string;
    NAME: string;
    CIRCLE_LOADER: string;
    TICK: string;
    LINK_ACCOUNT: string;
    DIALOG_HEADER: {
        ICON: string;
        TEXT: string;
    };
    DIALOG_CONTENT: {
        WRAPPER: string;
        META_POINT: string;
        TNC_LINK: string;
        METHOD_NAME: string;
        EMAIL: string;
        MOBILE: string;
    };
    PAY_BUTTON: string;
    DUE_DATE_MESSAGE: string;
    ALERT_MESSAGE: string;
}
export const PROMO_MSG_TEXT = "promo-msg";

const PAYLATER_TEST_ID_PREFIX = {
    [PAYLATER_TYPES.LAZYPAY]: "lp",
    [PAYLATER_TYPES.PAYTM_POSTPAID]: "pp",
    [PAYLATER_TYPES.SIMPL]: "sp",
    [PAYLATER_TYPES.AMAZON_PAYLATER]: "apl",
};

const getPayLaterPrefix = (paymentCode: string): string => {
    const payLaterCode = paymentCode as PAYLATER_TYPES;
    return PAYLATER_TEST_ID_PREFIX[payLaterCode] ?? "pl";
};

export const getPayLaterTestIds = (paymentCode: string): PayLaterTestIds => {
    const payLaterPrefix = getPayLaterPrefix(paymentCode);
    const dialogHeaderPrefix = `${payLaterPrefix}_dh`;
    const dialogContentPrefix = `${payLaterPrefix}_dc`;

    return {
        CONTAINER: `${payLaterPrefix}_container`,
        ICON: `${payLaterPrefix}_icon`,
        NAME: `${payLaterPrefix}_name`,
        CIRCLE_LOADER: `${payLaterPrefix}_circle_loader`,
        TICK: `${payLaterPrefix}_tick`,
        LINK_ACCOUNT: `${payLaterPrefix}_link_acc`,
        DIALOG_HEADER: {
            ICON: `${dialogHeaderPrefix}_icon`,
            TEXT: `${dialogHeaderPrefix}_text`,
        },
        DIALOG_CONTENT: {
            WRAPPER: `${dialogContentPrefix}`,
            META_POINT: `${dialogContentPrefix}_meta_point`,
            TNC_LINK: `${dialogContentPrefix}_tnc_link`,
            METHOD_NAME: `${dialogContentPrefix}_method_name`,
            EMAIL: `${dialogContentPrefix}_email`,
            MOBILE: `${dialogContentPrefix}_mobile`,
        },
        PAY_BUTTON: `${payLaterPrefix}_pay_btn`,
        DUE_DATE_MESSAGE: `${payLaterPrefix}_due_dt_msg`,
        ALERT_MESSAGE: `${payLaterPrefix}_alert_msg`,
    };
};
